// MSAL configuration for Microsoft Authentication
export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID || ''}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

// Add scopes for Microsoft Graph API access
export const graphScopes = {
  // Delegated permissions (user context)
  scopes: ['Sites.ReadWrite.All', 'User.Read'],
  // Application permissions (app-only context)
  applicationScopes: ['https://graph.microsoft.com/.default']
};

// SharePoint site and list configuration
export const sharepointConfig = {
  siteUrl: import.meta.env.VITE_SHAREPOINT_SITE_URL || '',
  vynterface: {
    listName: import.meta.env.VITE_SHAREPOINT_VYNTERFACE_LIST_NAME || 'Vynterface Waitlist',
    sitePath: import.meta.env.VITE_SHAREPOINT_VYNTERFACE_SITE_PATH || '/sites/invyteout', // Both lists might be on the same site
  },
  invyteout: {
    listName: import.meta.env.VITE_SHAREPOINT_INVYTEOUT_LIST_NAME || 'InvyteOut Waitlist',
    sitePath: import.meta.env.VITE_SHAREPOINT_INVYTEOUT_SITE_PATH || '/sites/invyteout',
  }
};
